import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Button, IconButton, Paper, Switch, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import toast from 'react-hot-toast';
import SoftButton from 'components/SoftButton';
import { useAuth } from 'AuthContext';



const User = () => {
  const navigate = useNavigate()
const [ isApiLoading , setIsApiLoading ] = React.useState(true)
  const [data, setData] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const columns = [
    {
      id: 'name',
      label: 'Name',
      orderBy: 'name',
      isSorting: true, sortDirection: 'asc'
    },
    {
      id: 'category', isSorting: true,sortDirection:'asc',label: 'Category',
      render: (row) => {
        return <span>{row?.categories && row?.categories?.map((item) => item.name)?.join(', ')  || "N/A"}</span>;
      }
    },
    {
      id: 'logo',
      label: 'Logo',
      isSorting: false,
      render: (row) => (
        row.logo ?
          <img
            src={row.logo}
            alt="Logo"
            style={{ width: 40, height: 40, objectFit: 'contain', border: '1px solid #ccc', borderRadius: 4 }}
          /> : 'N/A'
      ),
    },
    {
      id: 'action',
      label: 'Action',
      isSorting: false,
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'Edit', onClick: () => navigate(`/admin/edit-amenities/${row._id}`) },
            { label: 'Delete', onClick: () => deleteAmenities(row._id) },
          ]}
        />
      ),
    },
  ];


  const deleteAmenities = async (id) => {
    try {
      const response = await service.amenities.delete(id);

      if ([200, 201].includes(response.status)) {
        toast.success(response.message || 'Amenities deleted successfully.');
        getUserDetail();
      } else {
        toast.error(response.message || 'Failed to delete Amenities.');
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'An error occurred while deleting the Amenities.';
      toast.error(errorMessage);
      console.error('Deletion error:', error);
    }
  };
  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      const response = await service.amenities.view({ searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection });
      if (response?.data?.data) {
        setData(response.data);
      }
      
    } catch (error) {
      console.error("Failed to fetch business users", error);
    }
    setIsApiLoading(false)
  };

  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage, sortValue]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
        <Box display="flex" alignItems="center" justifyContent={'end'}>
          <SoftButton variant="gradient" color="info" onClick={() => navigate('/admin/add-amenities')}>Add</SoftButton>
        </Box>

        <CustomTable
          title="Amenities List" columns={columns}
          rows={data?.data}
          search={search}
          setSearch={setSearch}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          isApiLoading={isApiLoading}
          totalPages={data?.pagination?.totalItems}
          onRequestSort={(id, direction) => {
            setSortValue({ sortKey: id, sortDirection: direction })

          }}
        />
      </Paper>
    </DashboardLayout>
  );
}

export default User
